exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".addhead[data-v-65a8e4b7]{margin-top:20px;padding-right:20px}.addhead ul li[data-v-65a8e4b7]{width:100%}\n", ""]);

// exports
